export default __webpack_public_path__ + "static/media/crane-1.c1d71c97.png";